import styled from "styled-components";

export const Percent = styled.span`
  color: gray;
`;

export const Position = styled.div`
  & > table {
    // border-collapse: collapse;
    margin: 0 auto;
    border-spacing: 0;

    td {
      border: 1px solid #3495eb;
      text-align: center;
      padding: 6px;
    }

    tr:nth-child(1) td,
    tr:nth-child(3) td {
      background: #3495eb;
      font-weight: 700;
      padding: 8px 10px;
    }

    tr:first-child td:first-child {
      border-top-left-radius: 6px;
    }
    tr:first-child td:last-child {
      border-top-right-radius: 6px;
    }
    tr:last-child td:first-child {
      border-bottom-left-radius: 6px;
    }
    tr:last-child td:last-child {
      border-bottom-right-radius: 6px;
    }
    tr:not(:first-child) td {
      border-top-width: 0;
    }
    tr td:not(:first-child) {
      border-left-width: 0;
    }
  }

  &:not(:last-child) table {
    margin-bottom: 20px;
  }
`;

export const Shelf = styled.div`
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  width: 154px;
  margin: 0 auto 10px auto;
  padding: 4px 15px;
  border: 1px solid #3495eb;
  border-radius: 5px;
`;
